import Component from './Component'
import State from './State'
import Controller from './Controller'

const component = Component

const WebForm = new class {

    initComponent(currentOffset, audio, seenTCPAId, recordTCPA) {

        component.setProps(currentOffset, audio, seenTCPAId, recordTCPA)

        return component

    }

    get component() {
        return component
    }

    get state() {
        return State
    }

    get controller() {
        return Controller
    }

}()

export default WebForm
